module.exports = __webpack_public_path__ + "img/ApprovalE.672b4f94.png";